import { render } from "./PasswordReset.vue?vue&type=template&id=f5de412e&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"

import "./PasswordReset.vue?vue&type=style&index=0&id=f5de412e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eeej-spa/eeej-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5de412e"]])

export default __exports__